import React from "react";

const Overview = () => {
	return <div>Overview</div>;
};

export default Overview;
